export default __webpack_public_path__ + "static/media/payment-methods@2x.d078a595.jpg";